import { getNewRoleMetrics } from 'modules/Applied_Roles/actions'
import { getFunctionsList, getListOfSkills } from 'modules/Onboarding/actions'
import selector2 from 'modules/Onboarding/selectors'
import {
  getStudentData,
  updateStudent,
  updateStudentData,
} from 'modules/Resume/actions'
import {
  ApplyRole,
  SaveRole,
  getCities,
  getCompTypeList,
  getEligibleDetails,
  getRoleCities,
  getRoleFloatDetails,
  getRolesList,
  getSingleRoleDetails,
  getSkillLocationFilterData,
  getStudentRoleList,
  getStudentRuleSet,
  updateRoleFloatDetails,
} from 'modules/Roles/actions'
import Roles from 'modules/Roles/index'
import selector from 'modules/Roles/selectors'
import { connect } from 'react-redux'
import {
  rejectStudentStatus,
  studentOptedStatus,
} from '../../Dashboard/actions'
import selectors from '../../Dashboard/selectors'
const mapStateToProps = state => ({
  rolesList: selector.getRolesList(state),
  singleRoleDetails: selector.getSingleRoleDetails(state),
  citiesList: selector.getCities(state),
  citiesRoleList: selector.getRoleCities(state),
  eligibleDetails: selector.getEligibleDetails(state),
  roleFloatDetails: selector.getRoleFloatDetailsData(state),
  collegeData: selector2.getCampuDetails(state),
  functionsList: selector2.getFunctionsList(state),
  studentDetails: selector2.getStudentResumeData(state),
  studentData: selector2.getStudentDetails(state),
  optoutStatus: selectors.getOptOutStatus(state),
})

const mapDispatchToProps = {
  ApplyRole,
  SaveRole,
  getRolesList,
  getSingleRoleDetails,
  getEligibleDetails,
  getRoleFloatDetails,
  getFunctionsList,
  getCities,
  getListOfSkills,
  getStudentData,
  updateStudentData,
  updateRoleFloatDetails,
  getRoleCities,
  getStudentRoleList,
  getCompTypeList,
  getSkillLocationFilterData,
  getStudentRuleSet,
  updateStudent,
  getNewRoleMetrics,
  studentOptedStatus,
  rejectStudentStatus,
}

export default connect(mapStateToProps, mapDispatchToProps)(Roles)
